<template>
  <div class="mobile-container">
    <div class="pb-05">
      <v-alert
        dense
        text
        type="warning"
        icon="mdi-shield-alert"
        class="caption-regular pr-4 py-3 mb-2"
        rounded="0"
      >
        تاریخ و ساعت بارگیری را مشخص کنید.
      </v-alert>
    </div>

    <v-card rounded="0" class="mb-3 pb-5 ev-0">
      <v-card-title class="high-emp subtitle1-regular pt-3 pb-05 px-4"
        >زمان بارگیری</v-card-title
      >
      <v-row class="mx-0">
        <div class="col-12 pb-0 px-4 pt-4">
          <input
            type="text"
            class="datepicker w-100 py-3 rounded border"
            id="datepicker"
            :placeholder="
              multipleLoadingPlace ? 'از تاریخ' : 'انتخاب تاریخ بارگیری'
            "
          />

          <date-picker
            custom-input=".datepicker"
            v-model="startLoadingDate"
            type="date"
            color="#5757F7"
            placeholder="تاریخ بارگیری"
            format="YYYY-MM-DD"
            display-format="jYYYY/jMM/jDD"
            :min="startMinDate"
            :initial-value="startMinDate"
            simple
          ></date-picker>
        </div>

        <div
          v-show="!multipleLoadingPlace"
          class="col-12 pb-0 px-4 pt-5 pt-md-4"
        >
          <input
            type="text"
            class="timepicker w-100 py-3 rounded border"
            placeholder="ساعت بارگیری ( اختیاری )"
            id="timepicker"
          />
          <date-picker
            simple
            custom-input=".timepicker"
            v-model="startLoadingTime"
            type="time"
            color="#5757F7"
            placeholder="ساعت بارگیری"
            format="YYYY-MM-DDTHH:mm:ss.sssZ"
            display-format="ساعت : HH:mm"
            :min="startMinTime"
            :initial-value="startMinTime"
            :jumpMinute="30"
            :roundMinute="true"
          ></date-picker>
        </div>

        <div v-show="multipleLoadingPlace" class="col-12 pb-0 px-4 pt-4">
          <input
            type="text"
            class="enddatepicker w-100 py-3 rounded border"
            id="enddatepicker"
            placeholder="تا تاریخ"
          />

          <date-picker
            custom-input=".enddatepicker"
            v-model="endLoadingDate"
            type="date"
            color="#5757F7"
            placeholder="تا تاریخ"
            format="YYYY-MM-DD"
            display-format="jYYYY/jMM/jDD"
            :min="startMinDate"
            :initial-value="startMinDate"
            simple
          ></date-picker>
        </div>
      </v-row>
    </v-card>

    <v-card class="mt-3 pb-3 py-1 ev-0" rounded="0">
      <v-card-title class="high-emp subtitle1-regular pt-3 pb-05 px-4"
        >روش انتشار بار :</v-card-title
      >

      <div class="row px-4 mt-4">
        <div
          v-for="option of publishOptions"
          :key="option.id"
          class="pb-3 pt-0 col-12"
        >
          <v-card
            :disabled="!hasHamkar || option.id == 10"
            @click="switchPublishOption(option)"
            class="pa-3 border border-grey cursor-pointer body2-regular"
            :class="option.active && 'active-option'"
            elevation="0"
          >
            <v-icon
              class="ml-2"
              :class="
                option.active
                  ? 'logistic--text force-color'
                  : 'grey--text text--lighten-1'
              "
              >{{
                option.active ? "mdi-check-circle" : "mdi-circle-outline"
              }}</v-icon
            >
            <span v-text="option.name"></span>
          </v-card>
        </div>
      </div>

      <p class="px-4 mt-2 mb-5 caption-regular grey--text text--darken-2">
        در صورت انتخاب گزینه <span class="black--text">باربری‌های همکار</span>،
        بار شما فقط برای باربری‌های همکاری که قبلاً ذخیره کردید ارسال می‌شود.
      </p>
    </v-card>
  </div>
</template>
    
<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  components: { datePicker: VuePersianDatetimePicker },
  props: {
    load: {
      type: Object,
      require: true,
    },
    permissions: {
      type: Array,
      require: true,
      default: [false, false, false, false],
    },
  },
  data() {
    return {
      validate: false,
      startLoadingDate: null,
      startLoadingTime: null,
      endLoadingDate: null,
      hasHamkar: false,
      publishOptions: [
        {
          name: "همه باربری ها",
          id: "20",
          active: true,
          value: false,
        },
        {
          name: "باربری‌های همکار ( بزودی )",
          id: "10",
          active: false,
          value: true,
        },
      ],
    };
  },
  watch: {
    startLoadingDate(val) {
      if (!val) {
        this.validate = false;
      }
      this.load.shipping_start_date = this.dateToIso(val);
      this.validate = true;
    },
    endLoadingDate(val) {
      if (!val) {
        this.validate = false;
      }
      this.load.shipping_end_date = this.dateToIso(val);
      this.validate = true;
    },
    startLoadingTime(val) {
      let formattedStartTime = val.toString().split("+");
      formattedStartTime = formattedStartTime[0] + "Z";
      this.load.loading_start_time = formattedStartTime;
    },
    validate(val) {
      this.permissions.splice(3, 1, val);
    },
  },
  mounted() {
    this.publishInit();
    this.checkHamkar();
  },
  methods: {
    dateToIso(date) {
      date = date.split("-");
      const year = Number(date[0]);
      const month = Number(date[1]) - 1;
      const day = Number(date[2]);

      let result = new Date();
      result.setFullYear(year, month, day);
      result = result.toISOString();

      return result;
    },
    switchPublishOption(op) {
      this.publishOptions.map((option) => (option.active = false));
      this.load.is_hamkar_load = op.value;
      op.active = true;
    },
    publishInit() {
      this.load.is_hamkar_load = false;
    },
    async checkHamkar() {
      let res = await this.$parseSDK.Cloud.run(
        "get_hamkar_barbaries_by_company",
        {
          skip_number: 0,
        }
      );
      if (res && res.length > 0) this.hasHamkar = true;
    },
  },
  computed: {
    multipleLoadingPlace() {
      let counter = this.load.senders_and_recievers.filter(
        (sr) => sr.is_sender === true
      ).length;
      if (counter > 1) return true;
      else return false;
    },
    startMinDate() {
      // calc start minimum date limit ...
      let now = new Date();
      let year = now.getFullYear().toString();
      let month = (now.getMonth() + 1).toString();
      let day = now.getDate().toString();
      let hour = (now.getHours() + 1).toString();
      let minute = now.getMinutes().toString();

      month.length == 1 ? (month = "0" + month) : (month = month);
      day.length == 1 ? (day = "0" + day) : (day = day);
      hour.length == 1 ? (hour = "0" + hour) : (hour = hour);
      minute.length == 1 ? (minute = "0" + minute) : (minute = minute);

      return year + "-" + month + "-" + day;
    },
    startMinTime() {
      // calc end minimum time limit ...
      const now = new Date();
      const hour = (now.getHours() + 1).toString();

      const today = new Date();
      let tYear = today.getFullYear().toString();
      let tMonth = (Number(today.getMonth()) + 1).toString();
      let tDay = today.getDate().toString();

      if (tYear.length === 1) tYear = "0" + tYear;
      if (tMonth.length === 1) tMonth = "0" + tMonth;
      if (tDay.length === 1) tDay = "0" + tDay;

      // format date according to date-picker date format
      const formattedToday = tYear + "-" + tMonth + "-" + tDay;

      if (this.load.startLoadingDate === formattedToday)
        return "2021-11-11T" + hour + ":00:00.000+03:30"; // just "hour" is important

      return null;
    },
  },
};
</script>

<style scoped>
.border {
  border: 1px solid #9e9e9e;
}
.min-height {
  min-height: calc(100vh - 298px);
}
</style>
